export default __webpack_public_path__ + "static/media/devices_wdc_lite_suspended.4cd6ea2f.svg";